// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__A4tqE","footer":"ModalInfo_footer__1VgPh"};